export enum DisplayOrdersPage {
  waitlist = 1,
  togo,
}
